export type RemappableFieldDefinition = {
  label: string;
  mdmProperty: string;
};

export const DUNS_MDM_PROPERTY = 'company_duns_number';

export const REMAPPABLE_ACCOUNT_FIELDS: RemappableFieldDefinition[] = [
  { label: 'DUNS Number', mdmProperty: DUNS_MDM_PROPERTY },
  { label: 'Industry', mdmProperty: 'company_industry' },
  { label: 'Number of Employees', mdmProperty: 'company_employees' },
  { label: 'Country', mdmProperty: 'company_country' },
  { label: 'Postal Code', mdmProperty: 'company_postal_code' },
  { label: 'Region', mdmProperty: 'company_region' },
  { label: 'City', mdmProperty: 'company_city' },
  { label: 'Address', mdmProperty: 'company_address' },
  { label: 'Company Phone Number', mdmProperty: 'company_phone_number' },
];

export const MDM_PROPERTY_LABELS: Record<string, string> = {
  company_name: 'Company Name',
  company_website: 'Company Website',
  company_key: 'Company ID',
  company_owner_id: 'Account Owner ID',
  company_duns_number: 'DUNS Number',
  company_industry: 'Industry',
  company_employees: 'Number of Employees',
  company_country: 'Country',
  company_postal_code: 'Postal Code',
  company_region: 'Region',
  company_city: 'City',
  company_address: 'Address',
  company_phone_number: 'Company Phone Number',
  person_name: 'Account Owner Name',
  person_email: 'Account Owner Email',
  person_phone: 'Account Owner Phone',
  deal_stage: 'Deal Stage',
  deal_type: 'Deal Type',
};
